import { type ConnectionId } from '@blaze-shared/api-contracts-domain';
import { NAMESPACE_LENGTH, type NamespaceId } from '@blaze-shared/workflow-domain';

export function getConnectionNamespaceId(connectionId: ConnectionId): NamespaceId {
  return connectionId.slice(0, NAMESPACE_LENGTH);
}

export function getNewConnectionId(namespaceId: string): ConnectionId {
  return `${namespaceId}_${crypto.randomUUID()}`;
}
